module.exports = __webpack_public_path__ + "img/combat.dfc619a2.png";